import * as Sentry from "@sentry/browser";
import Main from "./scenes/main";
import Start from "./scenes/start";
import LevelUp from "./scenes/levelup";
import Pause from "./scenes/pause";
import ChestOpen from "./scenes/chestOpen";
import { useAppStore } from "./state";

Sentry.init({
  environment: import.meta.env.DEV ? "development" : "production",
  dsn: "https://2e068f554424290ca8af0e687bdcf3bb@o4508558706933760.ingest.us.sentry.io/4508558709555200",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.replayCanvasIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const path = window.location.pathname;
if (path === "/steampage") {
  document.body.style.background = "gray";
  import("./tools/steampage");
} else {
  import("./game");
}
